import styled from 'styled-components';

export const Container = styled.div`
    height: 350px;
    padding-top: 220px;
    background-image: url("https://uploads-ssl.webflow.com/5b3db92fdf53bd5cfe96e75a/5b45a535485cea108955d31f_angel.svg"), linear-gradient(135deg, rgba(0, 77, 240, 0.92) 24%, rgba(0, 233, 94, 0.94));
    background-position: 0px 2.3px, 0px 0px;
    background-size: cover, auto;
    background-repeat: no-repeat, repeat;
    background-attachment: scroll, scroll;
    position: relative;
    padding-bottom: 0px;
`;